import { useState } from 'react';
import {
  DEFAULT_GOOGLE_MAPS_API_KEY,
  GrowthDashboardTopBarActions,
  LocalMarketIntelligenceView,
} from '@elva/ui';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import {
  useLocalMarket,
  useLocalMarketCompetitorDetail,
  useLocalMarketKeywords,
} from '../hooks/useLocalMarket';

const googleMapsApiKey =
  (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) || DEFAULT_GOOGLE_MAPS_API_KEY;

export function LocalMarketIntelligencePage() {
  const [radiusMiles, setRadiusMiles] = useState(8);
  const [selectedCompetitorId, setSelectedCompetitorId] = useState<string | null>(null);

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } =
    useLocalMarket(radiusMiles);
  const { data: keywords, isFetching: keywordsLoading } = useLocalMarketKeywords();
  const { data: competitorDetail, isFetching: competitorDetailLoading } =
    useLocalMarketCompetitorDetail(selectedCompetitorId);

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <LocalMarketIntelligenceView
        {...viewProps({
          clinicName: data?.clinicName ?? 'Your practice',
          clinicAddress: data?.clinicAddress ?? '',
          centerCoordinate: data?.centerCoordinate ?? null,
          googleMapsApiKey,
          competitors: data?.competitors,
          keywordOpportunities: keywords,
          analysisRadius: radiusMiles,
          onAnalysisRadiusChange: setRadiusMiles,
          loading: isFetching || keywordsLoading,
          competitorDetail,
          competitorDetailLoading,
          onCompetitorSelect: setSelectedCompetitorId,
        })}
      />
    </AsyncBoundary>
  );
}
